import { Redline } from 'redline-client-sdk';
import { RLMatchMakerEvents } from '../types';
import { pixel } from './pixel';

export const MatchMakerEvents = (rl: Redline): RLMatchMakerEvents => ({
  decisionProcessed: (payload = {}) => {
    const event = 'matchmaker.DecisionProcessed.v1';
    rl.track(event, { event, ...payload });
    pixel(event, { event, ...payload });
  },
});
